import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

type ConsoleDestination = "/employer" | "/employer-preview";

export const Route = createFileRoute("/checkout_/thank-you")({
  validateSearch: (search: Record<string, unknown>): { to?: ConsoleDestination } => {
    if (search["to"] === "/employer-preview") return { to: "/employer-preview" };
    if (search["to"] === "/employer") return { to: "/employer" };
    return {};
  },
  head: () => ({
    meta: [
      { title: "Payment successful | CLOSDD" },
      {
        name: "description",
        content: "Your payment was successful. You can now view all candidates for this role.",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ThankYouPage,
});

function ThankYouPage() {
  const { to } = Route.useSearch();
  const consoleTo = to ?? "/employer";
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      void navigate({ to: consoleTo });
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate, consoleTo]);

  return (
    <div className="grid min-h-screen place-items-center bg-[#f6f8fc] px-5 text-center">
      <div className="flex max-w-[560px] flex-col items-center">
        <span className="grid h-16 w-16 place-items-center rounded-full bg-tag-green-soft text-tag-green">
          <svg
            viewBox="0 0 24 24"
            className="h-8 w-8"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
          >
            <path d="M5 12.5 9.5 17 19 7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
        <h1 className="mt-6 font-serif text-[26px] leading-[1.1] tracking-[-0.025em] text-ink sm:text-[32px]">
          Thank you!
        </h1>
        <p className="mt-4 text-[16px] leading-[1.6] text-ink/60">
          Your payment was successful. You can now view all candidates for this role.
        </p>
        <Link
          to={consoleTo}
          className="mt-8 inline-flex items-center justify-center rounded-lg bg-purple-strong px-7 py-3.5 text-[13.5px] font-semibold text-white shadow-[0_10px_30px_-12px_rgba(82,0,128,0.6)] transition-colors hover:bg-purple-mid"
        >
          Go to dashboard
        </Link>
      </div>
    </div>
  );
}
